import { makeStyles } from '@material-ui/core/styles';
import { TextColors, SecondaryColors } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $title': {
      color: TextColors.light,
    },

    '& $superHeading': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  root: {
    '& $title': {
      color: TextColors.dark,
    },

    '& $superHeading': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
    },
    wrapper: {
      position: 'relative',
      width: '100%',
      marginBottom: muiTheme.spacing(-4),

      [muiTheme.breakpoints.up('md')]: {
        marginBottom: muiTheme.spacing(-11),
      },
    },

    title: {
      '&.MuiTypography-root': {
        marginBottom: '-.125em',
      },
    },

    superHeading: {
      '&.MuiTypography-root': {
        marginBottom: muiTheme.spacing(2),
      },
    },
  }),
  { name: 'GenStackedCardList' },
);

export default useStyles;
